import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {t} from 'i18next';

// Define error mappings with translation keys
const ERROR_MAPPING = {
    37: {
        messageKey: 'error.identity.title',
        subMessageKey: 'error.identity.subtitle',
        descriptionKey: 'error.identity.description'
    },
    41: {
        messageKey: 'error.identity.title',
        subMessageKey: 'error.identity.subtitle',
        descriptionKey: 'error.identity.description'
    },
    68: {
        messageKey: 'error.canceled.title2',
        subMessageKey: 'error.canceled.subtitle',
        descriptionKey: null
    },
    79: {
        messageKey: 'error.invalid.account.title',
        subMessageKey: 'error.invalid.account.subtitle',
        descriptionKey: 'error.invalid.account.description'
    },
    72: {
        messageKey: 'error.unsupported.account.title',
        subMessageKey: 'error.unsupported.account.subtitle',
        descriptionKey: 'error.unsupported.account.description'
    },
    '404_DEVICEDATA': {
        messageKey: 'error.device.title',
        subMessageKey: 'error.device.subtitle',
        descriptionKey: 'error.device.description'
    },
    default: {
        messageKey: 'error.generic.title',
        subMessageKey: 'error.generic.subtitle',
        descriptionKey: 'error.generic.description'
    }
};

export const useMappingErrorMessage = () => {

    const appStore = useSelector((state) => state, shallowEqual).app;
    const { obvInfo, error, deviceData } = appStore;

    const mappedError = useMemo(() => {
        if(error === null || error === undefined){
            return null;
        }

        const errorConfig = ERROR_MAPPING[error.errorId] || ERROR_MAPPING.default;
        
        // Get translated messages from i18n
        let message = t(errorConfig.messageKey);
        let subMessage = errorConfig.subMessageKey ? t(errorConfig.subMessageKey) : null;
        let description = errorConfig.descriptionKey ? t(errorConfig.descriptionKey) : null;

        // Replace placeholders in subMessage with actual values from obvInfo
        if (subMessage) {
            if (subMessage.includes('#MERCHANT_NAME#')) {
                // Ensure obvInfo has merchantName to prevent undefined replacement
                const merchantName = obvInfo?.merchantName || 'the merchant';
                subMessage = subMessage.replace('#MERCHANT_NAME#', merchantName);
            }
            if (subMessage.includes('#ACCOUNT_MASK#')) {
                // Ensure obvInfo has accountMask to prevent undefined replacement
                const accountMask = obvInfo?.accountMask || '****';
                subMessage = subMessage.replace('#ACCOUNT_MASK#', accountMask);
            }
            if (subMessage.includes('#DEVICE_ID#')) {
                // Ensure obvInfo has accountMask to prevent undefined replacement
                const deviceId = deviceData?.primaryDeviceId || deviceData?.secondaryDeviceId || '';
                subMessage = subMessage.replace('#DEVICE_ID#', deviceId);
            }
        }

        return { message, subMessage, description };
    }, [error, obvInfo, deviceData]);

    return mappedError;
}